import {
  EMAIL_VALIDATION_MESSAGE,
  GENERIC_VALIDATION_MESSAGE,
  PASSWORD_CONFIRM_VALIDATION_MESSAGE,
  PASSWORD_VALIDATION_MESSAGE,
  TEL_VALIDATION_MESSAGE
  // TOC_VALIDATION_MESSAGE
} from '../constants';

const CLASSNAME = 'blaze-registration-form';

const getInitFormState = (overrides = {}) => {
  const formState = {
    title: {
      value: '',
      error: null,
      validationMessage: GENERIC_VALIDATION_MESSAGE,
      isRequired: true
    },
    firstname: {
      value: '',
      error: null,
      validationMessage: GENERIC_VALIDATION_MESSAGE,
      isRequired: true
    },
    lastname: {
      value: '',
      error: null,
      validationMessage: GENERIC_VALIDATION_MESSAGE,
      isRequired: true
    },
    jobTitle: {
      value: '',
      error: null,
      validationMessage: GENERIC_VALIDATION_MESSAGE,
      isRequired: false
    },
    company: {
      value: '',
      error: null,
      validationMessage: GENERIC_VALIDATION_MESSAGE,
      isRequired: false
    },
    tel: {
      value: '',
      error: null,
      validationMessage: TEL_VALIDATION_MESSAGE,
      isRequired: true
    },
    email: {
      value: '',
      error: null,
      validationMessage: EMAIL_VALIDATION_MESSAGE,
      isRequired: true
    },
    address1: {
      value: '',
      error: null,
      validationMessage: GENERIC_VALIDATION_MESSAGE,
      isRequired: true
    },
    address2: { value: '', error: null },
    postcode: {
      value: '',
      error: null,
      validationMessage: GENERIC_VALIDATION_MESSAGE,
      isRequired: true
    },
    country: {
      value: '',
      error: null,
      validationMessage: GENERIC_VALIDATION_MESSAGE,
      isRequired: true
    },
    county: {
      value: ''
    },
    city: {
      value: '',
      error: null,
      validationMessage: GENERIC_VALIDATION_MESSAGE,
      isRequired: true
    },
    password: {
      value: '',
      error: null,
      validationMessage: PASSWORD_VALIDATION_MESSAGE,
      isRequired: true
    },
    passwordConfirm: {
      value: '',
      error: null,
      validationMessage: PASSWORD_CONFIRM_VALIDATION_MESSAGE,
      isRequired: true
    },
    newsletterOptOut: {
      value: false,
      error: null,
      isRequired: false,
      validationMessage: GENERIC_VALIDATION_MESSAGE
    }
    // todo: check if needed after feedback
    // tocAccepted: {
    //   value: false,
    //   error: null,
    //   isRequired: true,
    //   validationMessage: TOC_VALIDATION_MESSAGE
    // }
  };

  Object.entries(overrides).forEach(([key, { value, isRequired, remove }]) => {
    if (remove) {
      formState[key].remove = true;
    }
    if (value) {
      formState[key].value = value;
    }
    if (isRequired !== undefined) {
      formState[key].isRequired = isRequired;
    }
  });

  return formState;
};

export {
  EMAIL_VALIDATION_MESSAGE,
  GENERIC_VALIDATION_MESSAGE,
  PASSWORD_VALIDATION_MESSAGE,
  PASSWORD_CONFIRM_VALIDATION_MESSAGE,
  CLASSNAME,
  getInitFormState
};
